import { Avatar, Menu, ActionIcon } from "@mantine/core";
import { IconLogout, IconRefresh } from "@tabler/icons-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { localUser, logout, updateMe } from "@/services/session-service";


interface Props {
    className?: string;
    isCollapsed?: boolean;
    inline?: boolean;
}


export default function UserMenu({ className, isCollapsed = false, inline = false }: Props): JSX.Element {
    const { t } = useTranslation();
    const user = localUser();

    useEffect(() => {
        updateMe(true);
    }, []);

    if (inline) {
        return (
            <div className="flex items-center gap-3 w-full px-2 py-1 bg-gray-50/50 border border-gray-100 rounded-xl">
                <div className="flex-shrink-0">
                    <Avatar size={36} color="green" />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-bold text-slate-800 truncate">
                        {user?.name}
                    </div>
                    <div className="text-xxs text-gray-500 font-light truncate">
                        {user?.tenant_name} (#{user?.tenant_id} )
                    </div>
                    <div className="text-xxs text-gray-400 truncate">
                        {user?.email} (#{user?.id})
                    </div>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                    <ActionIcon
                        variant="subtle"
                        color="gray"
                        size="md"
                        onClick={() => updateMe(true)}
                        title={t('refresh')}
                    >
                        <IconRefresh size={18} />
                    </ActionIcon>
                    <ActionIcon
                        variant="subtle"
                        color="red"
                        size="md"
                        onClick={() => logout()}
                        title={t('logout')}
                    >
                        <IconLogout size={18} />
                    </ActionIcon>
                </div>
            </div>
        );
    }

    return (
        <Menu
            shadow="xl"
            radius="md"
        >
            <Menu.Target>
                <div className="cursor-pointer text-xs text-gray-500 font-semibold hover:text-black flex items-center w-full h-8">
                    <div className="w-9 h-8 flex items-center justify-center flex-shrink-0">
                        <Avatar size={24} color="green" />
                    </div>
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out flex-1 text-left
                        ${isCollapsed ? 'max-w-0 opacity-0 pointer-events-none' : 'max-w-xs opacity-100 pl-2'}
                    `}>
                        <span className="truncate block whitespace-nowrap">{user?.name}</span>
                    </div>
                </div>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>
                    <div className="text-sm font-extrabold text-gray-900 mb-2">
                        {user?.name}
                        <div className="text-xxs text-gray-500 font-light">
                            {user?.tenant_name} (#{user?.tenant_id})
                        </div>
                    </div>
                    <div className="text-xxs text-gray-500">
                        {user?.email} (#{user?.id})
                    </div>
                </Menu.Label>

                <Menu.Divider />

                <Menu.Item
                    leftSection={<IconRefresh size={14} />}
                    onClick={() => updateMe(true)}
                >
                    {t('refresh')}
                </Menu.Item>

                <Menu.Divider />

                <Menu.Item
                    color="var(--color-red)"
                    leftSection={<IconLogout size={14} />}
                    onClick={() => logout()}
                >
                    {t('logout')}
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
}